import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getList = (state: IRootState) => state.systemInoperability.systemInoperabilityList;
export const getOrder = (state: IRootState) => state.systemInoperability.systemInoperabilityListOrder;
export const getTotalCount = (state: IRootState) => state.systemInoperability.systemInoperabilityListTotalCount;
export const getListPage = (state: IRootState) => state.systemInoperability.systemInoperabilityListPage;
